import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpEventType } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { Sessions } from 'src/app/libraries/sessions';
import { IReturn } from 'src/app/libraries/ireturn';
import { APP_BASE_HREF } from '@angular/common';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ClientesService {

  constructor(private http: HttpClient,  @Inject(APP_BASE_HREF) private baseUrl: string) { }

  index(): Observable<IReturn> {
    return this.http.post<IReturn>(this.baseUrl + "api/Clientes/Index", null, Sessions.header());
  }

  dataSource(varArgs : any = null): Observable<IReturn> {
    return this.http.post<IReturn>(this.baseUrl + "api/Clientes/DataSource", varArgs, Sessions.header());
  }

  store(objCliente : any): Observable<IReturn> {
    return this.http.post<IReturn>(this.baseUrl + "api/Clientes/Store", objCliente, Sessions.headerFormData());
  }

  storeExpres(objCliente : any): Observable<IReturn> {
    return this.http.post<IReturn>(this.baseUrl + "api/Clientes/StoreExpres", objCliente, Sessions.header());
  }

  update(objCliente : any): Observable<IReturn> {
    return this.http.post<IReturn>(this.baseUrl + "api/Clientes/Update", objCliente, Sessions.header());
  }

  delete(objCliente : any): Observable<IReturn> {
    return this.http.post<IReturn>(this.baseUrl + "api/Clientes/Delete", objCliente, Sessions.header());
  }

}